import React, { FC } from 'react';
import { Box } from '@mui/material';
import { TextInput, EnumDropdown, useFormContext } from 'framework/form';
import { EDITABLE_LIST_FIELD } from 'framework/list';
import { FormattedTextField } from 'framework/ui/field';
import { SanitizedHtml } from 'framework/utils';
import { PROJECT_MEMBERSHIP_ROLES } from 'domain/shared/core/constants';
import { compactDisabledInputSx } from 'domain/projects/newProject/shared/compactDisabledInputSx';
import PredecessorSection from './PredecessorSection';

const ROLE_OPTIONS = {
  PROJECT_MANAGER: PROJECT_MEMBERSHIP_ROLES.PROJECT_MANAGER,
  QA_MANAGER: PROJECT_MEMBERSHIP_ROLES.QA_MANAGER,
  TEAM_LEAD: PROJECT_MEMBERSHIP_ROLES.TEAM_LEAD,
  BUSINESS_ANALYST: PROJECT_MEMBERSHIP_ROLES.BUSINESS_ANALYST,
};

const getTableCells = async (isEditMode: boolean) => {
  const disabled = !isEditMode;
  return [
    {
      type: EDITABLE_LIST_FIELD,
      source: 'number',
      isEditor: true,
      component: TextInput,
      componentProps: { label: '', disabled: true },
      gridCellProps: { size: 0.5, sx: compactDisabledInputSx },
    },
    {
      type: EDITABLE_LIST_FIELD,
      source: 'description',
      isEditor: false,
      component: FormattedTextField,
      componentProps: {
        label: '',
        format: (str: string) => (
          <Box
            sx={{
              height: 38,
              px: 1.75,
              py: 1,
              borderRadius: 1,
              border: '1px solid',
              borderColor: 'action.disabled',
              backgroundColor: 'common.inputDisabledBackground',
              color: 'text.disabled',
              display: 'flex',
              alignItems: 'center',
              overflow: 'hidden',
              '& > div': {
                width: '100%',
                maxHeight: '1lh',
                overflow: 'hidden',
                wordBreak: 'break-word',
              },
              '& *': {
                m: 0,
                p: 0,
                listStyle: 'none',
                fontSize: 'inherit',
                lineHeight: 'inherit',
              },
            }}
          >
            <SanitizedHtml html={str ?? ''} wrapperTag={'div'} />
          </Box>
        ),
      },
      gridCellProps: { size: 7.5 },
    },
    {
      type: EDITABLE_LIST_FIELD,
      source: 'assignedRole',
      isEditor: true,
      component: EnumDropdown,
      componentProps: { label: 'Role', options: ROLE_OPTIONS, sx: { mb: 0 }, disabled },
      gridCellProps: { size: 3.5 },
    },
  ];
};

const PredecessorAssumptions: FC = () => {
  const { data } = useFormContext();
  const assumptions = data?.assumptions ?? [];

  return (
    <PredecessorSection
      title="Assumptions"
      listSource="assumptions"
      isEmpty={assumptions.length === 0}
      getTableCells={getTableCells}
    />
  );
};

export default PredecessorAssumptions;
